import { render } from "./notFound.vue?vue&type=template&id=7cc9d12f&scoped=true"
const script = {}

import "./notFound.vue?vue&type=style&index=0&id=7cc9d12f&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc9d12f"]])

export default __exports__